<template>
  <b-modal :id="modalId" :title="title">
    <p class="m-2" v-if="body">{{ body }}</p>

    <b-list-group class="mb-3">
      <b-list-group-item
        ><strong>{{ $t('table.header.buyer') }}:</strong> {{ buyerName }},
        {{ location }}</b-list-group-item
      >
      <b-list-group-item
        v-if="targetStatus === 'won' || targetStatus === 'repwon'"
        ><strong>{{ $t('quote_form.total_cost') }}:</strong>
        {{ totalCost | currency(currency) }}
        <small>{{
          ` ${$t('quote_form.total_cost_ex_vat_label').toLowerCase()}`
        }}</small></b-list-group-item
      >
    </b-list-group>

    <section v-if="targetStatus === 'won' || targetStatus === 'repwon'">
      <i>
        <small class="text-muted">{{
          $t('messages.confirm_msg_won_description', {
            provision: provisionPercent,
          })
        }}</small></i
      >

      <LeadPaymentChange
        :provisionPercent="provisionPercent"
        :currentStatus="currentStatus"
        @updatePaymentPreferences="
          (preference) => (paymentPreference = preference)
        "
      />
    </section>

    <DeclinedForm
      @declineReason="(reason) => (declinedReason = reason)"
      v-if="targetStatus === 'declined'"
    />

    <CompliantForm
      :provisionLeadId="provisionLeadId"
      v-if="targetStatus === 'invalid'"
      @submit="
        $emit('confirm', {
          paymentPreference,
          declinedReason,
        })
      "
    />

    <template v-slot:modal-footer="{ cancel }">
      <b-button class="float-right" @click="cancel">
        {{ $t('buttons.cancel') }}
      </b-button>

      <b-button
        class="float-right"
        :variant="actionButtonVariant"
        @click="
          $emit('confirm', {
            paymentPreference,
            declinedReason,
          })
        "
        v-if="actionButtonText"
      >
        <b-icon :icon="actionButtonIcon" v-if="actionButtonIcon" />
        {{ actionButtonText }}
      </b-button>
    </template>
  </b-modal>
</template>
<script>
import LeadPaymentChange from '@/components/LeadPaymentChange.vue';
import DeclinedForm from '@/components/DeclinedForm.vue';
import CompliantForm from '@/components/CompliantForm.vue';

export default {
  components: {
    LeadPaymentChange,
    DeclinedForm,
    CompliantForm,
  },
  props: {
    modalId: {
      default: '',
      type: String,
    },
    title: {
      default: '',
      type: String,
    },
    body: {
      default: '',
      type: String,
    },
    buyerName: {
      default: '',
      type: String,
    },
    location: {
      default: '',
      type: String,
    },
    totalCost: {
      default: 0,
      type: Number,
    },
    currency: {
      default: '',
      type: String,
    },
    currentStatus: {
      default: '',
      type: String,
    },
    targetStatus: {
      default: '',
      type: String,
    },
    provisionLeadId: {
      default: 0,
      type: Number,
    },
    provisionPercent: {
      default: 0,
      type: Number,
    },
    actionButtonText: {
      default: '',
      type: String,
    },
    actionButtonIcon: {
      default: '',
      type: String,
    },
    actionButtonVariant: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      declinedReason: null,
      paymentPreference: '', //Default to today
    };
  },
};
</script>
